import actions from '@/core/store/item-adesao/actions'

export default {
	actions,
}
